function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M16.865 0H1.155C.52 0 0 .52 0 1.155v11.216c0 .636.52 1.155 1.155 1.155h3.308a3.925 3.925 0 013.36 2.162c.456.764.795 1.516.996 2.195.053.18.308.18.36 0 .202-.679.53-1.431.987-2.195a3.942 3.942 0 013.37-2.162h3.308c.636 0 1.155-.52 1.155-1.155V1.155A1.127 1.127 0 0016.865 0zm-5.93 9.795H7.085a.769.769 0 110-1.537h3.848a.769.769 0 110 1.537zm1.97-3.965h-7.79a.769.769 0 010-1.537h7.79a.769.769 0 110 1.537z",
  fill: "currentColor",
  fillRule: "evenodd"
})));